import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LoginService } from '../auth/login/login.service';
import { MyDataService } from '../data/data.service';
import { TranslocoService } from '@ngneat/transloco';
@Injectable({
  providedIn: 'root',
})
export class MailService {
  constructor(
    private http: HttpClient,
    public router: Router,
    private loginSvc: LoginService,
    private dataSvc: MyDataService,
    private translocoService: TranslocoService
  ) {}

  sendMailConfirmacion(
    email: string,
    ticketID: number,
    sn: string,
    username: string,
    seguimiento: any
  ): Observable<boolean> {
    
    return new Observable<boolean>((observer) => {
      const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
      const logo = this.dataSvc.getLogo();
      const logo2 = this.dataSvc.getLogo2();
      const logo3 = this.dataSvc.getLogo3();
      const lang = this.translocoService.getActiveLang();
      const body = {
        email,
        ticketID,
        sn,
        username,
        seguimiento,
        proyectoPlatform,
        lang,
        logo,
        logo2,
        logo3
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      this.http
        .post(
          environment.API_URL + '/clientesolicitante/send-mail-creacion-ticket',
          body,
          options
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (err) => {
            console.log('Error sendMailConfirmacion: ', err);

            observer.error(err);
          }
        );
    });
  }

  sendMailVerificacion(
    email: string,
    ticketId: number,
    serialNumber: string,
    username: string,
    seguimiento: boolean
  ): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
      const lang = this.translocoService.getActiveLang();
      const logo = this.dataSvc.getLogo();
      const logo2 = this.dataSvc.getLogo2();
      const logo3 = this.dataSvc.getLogo3();

      const body = {
        email,
        ticketId,
        serialNumber,
        username,
        seguimiento,
        proyectoPlatform,
        lang,
        logo,
        logo2,
        logo3
      };

      const options = {
        headers: new HttpHeaders({
          Authentication: 'Basic ' + environment.clientSecret,
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };

      const url = environment.API_URL + '/clientesolicitante/send-mail-verificacion-ticket';

      this.http.post(url, body, options).subscribe(
        (response: any) => {
          console.log('ws sendMailVerificacion:', response);
          observer.next(response);
        },
        (err) => {
          console.error('Error sendMailVerificacion:', err);
          observer.error(err);
        }
      );
    });
  }
}